import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/layout/Sidebar'
import { Topbar } from '@/components/layout/Topbar'
import { MobileNav } from '@/components/layout/MobileNav'
import { CommandPalette } from '@/components/layout/CommandPalette'
import { useApplyInterfaceLanguage } from '@/features/settings/hooks'
import { useT } from '@/internationalization/i18n'

/**
 * The authenticated frame: sidebar (lg+), sticky top bar, scrollable content.
 *
 * The page area is the scroll container, not <body> — that is what keeps the
 * top bar sticky and lets a screen pin its own sub-header (the transcript
 * player, a table's filter bar) without fighting the document scroll.
 *
 * `min-w-0` on the content column is load-bearing: without it a wide table or a
 * long unbroken transcript line stretches the flex row and the whole page
 * scrolls sideways.
 */
export function AppShell() {
  // Reads the server-side interface-language preference once and applies it
  // app-wide. Kept here because this is the frame every authenticated screen
  // renders inside.
  useApplyInterfaceLanguage()
  const t = useT()

  return (
    <div className="flex min-h-dvh bg-canvas">
      <aside className="hidden lg:block">
        <div className="sticky top-0 h-dvh">
          <Sidebar />
        </div>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <a href="#main" className="sb-skip-link">
          {t('nav.skipToContent')}
        </a>
        <Topbar />
        <main id="main" className="min-w-0 flex-1 px-3 py-4 sm:px-5 sm:py-6 lg:px-7">
          <div className="mx-auto w-full max-w-[1400px]">
            <Outlet />
          </div>
        </main>
      </div>

      <MobileNav />
      <CommandPalette />
    </div>
  )
}
